<template>
  <div class="file_upload_box">
    <van-uploader class="video_upload" type="file" accept="video/*" v-model="videoList" v-if="data.fileType==1" :multiple="data.uploadLength>1" :max-count="data.uploadLength" :after-read="afterVideoRead" :before-delete="deleteVideo" @click-preview="previewHandler">
      <template #preview-cover="{ }">
        <div class="preview-cover van-ellipsis">
          <van-icon name="play-circle-o" />
        </div>
      </template>
    </van-uploader>
    <van-uploader type="file" accept="audio/*" v-model="audioList" v-else-if="data.fileType==2" :multiple="data.uploadLength>1" :max-count="data.uploadLength" :after-read="afterAudioRead" :before-delete="deleteAudio"></van-uploader>
    <van-uploader type="file" accept="image/*" v-model="picList" v-else-if="data.fileType==3" :multiple="data.uploadLength>1" :max-count="data.uploadLength" :after-read="afterImgsRead" :before-delete="deleteImgs"></van-uploader>
    <div class="video_preview_dialog" v-if="showVideo">
      <div class="video_preview_box">
        <video controls controlslist="nodownload" disablepictureinpicture :src="src"></video>
      </div>
      <i role="button" class="van-icon van-icon-cross van-popup__close-icon van-popup__close-icon--top-right" @click="closeVideo"></i>
    </div>
  </div>
</template>
<script>
import { deepClone } from "@/utils";
import UploadServer from "@/api/apis/upload.js";
export default {
  name: "Upload",
  props: {
    data: {
      type: Object,
      default: null,
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      firstLoad: true, // 是否第一次加载
      resourceObj: null, // 初始化时传入的上传资源列表
      maxSize: 5 * 1024 * 1024, //5M大小
      picList: [], // 图片列表
      audioList: [], // 音频列表
      videoList: [], // 视频列表
      picResourceIdList: [], // 上传的图片 resourceId 列表
      audioResourceIdList: [], // 上传的音频 resourceId 列表
      videoResourceIdList: [], // 上传的视频 resourceId 列表
      showVideo: false, // 是否显示视频预览
      src: "", // 视频播放地址
      poster: "", // 视频封面图
    };
  },
  watch: {
    data: {
      handler(newValue, oldVue) {
        if (this.firstLoad && this.resourceObj == null) {
          this.resourceObj = deepClone(newValue);
          this.resourceObj.files.forEach(function (file, i) {
            file["id"] = file.resourceId;
          });
          if (this.resourceObj.fileType == 1) {
            this.videoList = this.resourceObj.files;
            this.videoResourceIdList = this.resourceObj.resourceIdList;
          } else if (this.resourceObj.fileType == 2) {
            this.audioList = this.resourceObj.files;
            this.audioResourceIdList = this.resourceObj.resourceIdList;
          } else if (this.resourceObj.fileType == 3) {
            this.picList = this.resourceObj.files;
            this.picResourceIdList = this.resourceObj.resourceIdList;
          }
        }
      },
      deep: true,
    },
  },
  methods: {
    /* 上传图片 */
    uploadPic(file) {
      var _this = this;
      UploadServer.fetchUploadPic(
        file.file,
        function (percentage) {
          file.message = percentage;
        },
        function (res) {
          if (res.suc == 1) {
            _this.picResourceIdList.push(res.resourceId);
            _this.$emit("uploadData", {
              index: _this.index,
              type: 3,
              list: _this.picResourceIdList,
            });
            file.url = res.url;
            file.id = res.resourceId;
            file.status = "done";
            file.message = "上传成功";
          } else {
            file.status = "failed";
            file.message = "上传失败";
          }
        }
      );
    },
    /* 上传图片 自行将文件上传至服务器 */
    afterImgsRead(file) {
      var _this = this;
      if (file instanceof Array) {
        for (var i = 0; i < file.length; i++) {
          let item = file[i];
          item.status = "uploading";
          item.message = "上传中...";
          _this.uploadPic(item);
        }
      } else {
        file.status = "uploading";
        file.message = "上传中...";
        _this.uploadPic(file);
      }
    },
    /* 移除图片 */
    deleteImgs(file) {
      var _this = this;
      var index = _this.picResourceIdList.indexOf(file.id);
      if (index > -1) {
        _this.picResourceIdList.splice(index, 1);
      }
      _this.$emit("uploadData", {
        index: _this.index,
        type: 3,
        list: _this.picResourceIdList,
      });

      return (file, name) => {
        let fileIndex = name.index;
        _this.picList[file].splice(fileIndex, 1);
      };
    },
    /* 上传音频 */
    uploadAudio(file) {
      var _this = this;
      UploadServer.fetchUploadAudio(
        file.file,
        function (percentage) {
          file.message = percentage;
        },
        function (res) {
          if (res.suc == 1) {
            _this.audioResourceIdList.push(res.resourceId);
            _this.$emit("uploadData", {
              index: _this.index,
              type: 2,
              list: _this.audioResourceIdList,
            });
            file.id = res.resourceId;
            file.status = "done";
            file.message = "上传成功";
          } else {
            file.status = "failed";
            file.message = "上传失败";
          }
        }
      );
    },
    /* 上传音频 自行将文件上传至服务器 */
    afterAudioRead(file) {
      var _this = this;
      if (file instanceof Array) {
        for (var i = 0; i < file.length; i++) {
          let item = file[i];
          item.status = "uploading";
          item.message = "上传中...";
          _this.uploadAudio(item);
        }
      } else {
        file.status = "uploading";
        file.message = "上传中...";
        _this.uploadAudio(file);
      }
    },
    /* 移除音频 */
    deleteAudio(file) {
      var _this = this;
      var index = _this.audioResourceIdList.indexOf(file.id);
      if (index > -1) {
        _this.audioResourceIdList.splice(index, 1);
      }
      _this.$emit("uploadData", {
        index: _this.index,
        type: 2,
        list: _this.audioResourceIdList,
      });
      return (file, name) => {
        let fileIndex = name.index;
        _this.audioList[file].splice(fileIndex, 1);
      };
    },
    /* 上传视频 */
    uploadVideo(file) {
      var _this = this;
      UploadServer.fetchUploadVideo(
        file.file,
        function (percentage) {
          file.message = percentage;
        },
        function (res) {
          if (res.suc == 1) {
            _this.videoResourceIdList.push(res.resourceId);
            _this.$emit("uploadData", {
              index: _this.index,
              type: 1,
              list: _this.videoResourceIdList,
            });
            file.url = res.url;
            file.id = res.resourceId;
            file.status = "done";
            file.message = "上传成功";
          } else {
            file.status = "failed";
            file.message = "上传失败";
          }
        }
      );
    },
    /* 上传视频 自行将文件上传至服务器 */
    afterVideoRead(file) {
      var _this = this;
      if (file instanceof Array) {
        for (var i = 0; i < file.length; i++) {
          let item = file[i];
          item.status = "uploading";
          item.message = "上传中...";
          _this.uploadVideo(item);
        }
      } else {
        file.status = "uploading";
        file.message = "上传中...";
        _this.uploadVideo(file);
      }
    },
    /* 移除视频 */
    deleteVideo(file) {
      var _this = this;
      var index = _this.videoResourceIdList.indexOf(file.id);
      if (index > -1) {
        _this.videoResourceIdList.splice(index, 1);
      }
      _this.$emit("uploadData", {
        index: _this.index,
        type: 1,
        list: _this.videoResourceIdList,
      });
      return (file, name) => {
        let fileIndex = name.index;
        _this.videoList[file].splice(fileIndex, 1);
      };
    },
    /* 视频预览 */
    previewHandler(file) {
      var _this = this;
      if (!!file.status && file.status == "uploading") {
        return
      } else {
        _this.showVideo = true;
        _this.src = file.url;
        // _this.poster = file.coverUrl;
      }
    },
    /* 关闭视频预览 */
    closeVideo() {
      var _this = this;
      _this.showVideo = false;
      _this.src = "";
    }
  },
  created() {
    UploadServer.startUpload();
  },
  destroyed() {
    UploadServer.stopUpload();
  }
};
</script>
<style scoped lang="scss">
.file_upload_box {
  .video_upload {
    /deep/.van-icon-description {
      display: none;
    }
    /deep/.van-uploader__file-name {
      display: none;
    }
    .preview-cover {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.3);
      .van-icon {
        position: absolute;
        left: 25px;
        top: 25px;
        font-size: 30px;
        color: #fff;
      }
    }
  }
}
.video_preview_dialog {
  position: fixed;
  top: 12.4vw;
  left: 0;
  z-index: 1000;
  width: 100%;
  height: calc(100% - 12.4vw);
  padding-top: 12.4vw;
  background-color: rgba(0, 0, 0, 0.9);
  .video_preview_box {
    position: relative;
    height: 100%;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    overflow: hidden;
    video {
      display: block;
      object-fit: contain;
      max-width: 100%;
      max-height: 100%;
    }
  }
}
</style>